import { Component, OnInit, Input} from '@angular/core';
import { CollaboratorsService } from 'src/app/services/collaborators.service';

@Component({
  selector: 'app-collaborators-logs',
  templateUrl: './collaborators-logs.component.html',
  styleUrl: './collaborators-logs.component.scss',
  standalone: false
})
export class CollaboratorsLogsComponent implements OnInit {
logsDisplayedColumns:string[] = [ 'targeted_email' , 'performed_by', 'Action', 'added at']
logs:any[] = [];
pagination: any = {};
loading = true;
@Input() uuid!: string;
@Input() userEmail!: string;  
@Input() userName!: string;

constructor(
  private collaboratorsService: CollaboratorsService
){}



ngOnInit():void{
  this.loadlogs();
}

pageChange(event:any) {
  const page = event.pageIndex + 1;
  const limit = event.pageSize;

  this.loadlogs(page, limit);
}


loadlogs(page:number = 1, limit:number = 10){
  console.log("Calling API with:", this.uuid);
   this.collaboratorsService.getLogs(this.uuid, page, limit)
    .subscribe({
      next:(res:any)=>{
        this.logs = res.logs;
        this.pagination = res.pagination;
        console.log("Collaborator Logs:", this.logs);
        this.loading = false
      },
      error:(err)=>{
        console.log(err);
         this.loading = false
      }
    });
}
}
